export default __webpack_public_path__ + "static/media/ConstruyendoElFuturo_CatalogoPatrocinios_221123.3a887289.pdf";